define( [
	"../../core"
], function( jQuery ) {
	"use strict";

	return jQuery.now();
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/ajax/var/nonce.js
// module id = 70
// module chunks = 0